export class API {
	
	static async getInvernaderoOptions(codAqua) {
		return [];
	}

	static async getEstructuras( pagination = -1, headers = null ) {
		const rawResponse = await fetch(`${sessionStorage.getItem('backendUrl')}/api/estructuras/?populate=*&_limit=${pagination}`, {
			method: 'get',
			headers: !headers ? {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			}: headers
		} );
		return await rawResponse.json();
	}

	static async getAnchos( pagination = -1, headers = null ) {
		const rawResponse = await fetch(`${sessionStorage.getItem('backendUrl')}/api/algovalidanchos/?populate=*&_limit=${pagination}`, {
			method: 'get',
			headers: !headers ? {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			}: headers
		} );
		return await rawResponse.json();
	}

	static async getMallas( pagination = -1, headers = null ) {
		const rawResponse = await fetch(`${sessionStorage.getItem('backendUrl')}/api/algovalidmallas/?populate=*&_limit=${pagination}`, {
			method: 'get',
			headers: !headers ? {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			}: headers
		} );
		return await rawResponse.json();
	}

	static async getCabeceras( pagination = -1, headers = null ) {
		const rawResponse = await fetch(`${sessionStorage.getItem('backendUrl')}/api/cabeceras/?populate=*&_limit=${pagination}`, {
			method: 'get',
			headers: !headers ? {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			}: headers
		} );
		return await rawResponse.json();
	}

	static async getPreguntas( pagination = -1, headers = null ) {
		const rawResponse = await fetch(`${sessionStorage.getItem('backendUrl')}/api/preguntas/?populate=*&_limit=${pagination}`, {
			method: 'get',
			headers: !headers ? {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			}: headers
		} );
		return await rawResponse.json();
	}

	static async getRespuestas( pagination = -1, headers = null ) {
		const rawResponse = await fetch(`${sessionStorage.getItem('backendUrl')}/api/respuestas/?populate[objetos_3_ds][populate][file]=*&_limit=${pagination}`, {
			method: 'get',
			headers: !headers ? {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			}: headers
		} );
		return await rawResponse.json();
	}
	static async getProhibicionesAm( pagination = -1, headers = null ) {
		const rawResponse = await fetch(`${sessionStorage.getItem('backendUrl')}/api/prohibiciones-ams/?populate[objetos_3_ds][populate][file]=*&_limit=${pagination}`, {
			method: 'get',
			headers: !headers ? {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			}: headers
		} );
		return await rawResponse.json();
	}
	static async getProhibicionesInt( pagination = -1, headers = null ) {
		const rawResponse = await fetch(`${sessionStorage.getItem('backendUrl')}/api/prohibiciones-ints/?populate[objetos_3_ds][populate][file]=*&_limit=${pagination}`, {
			method: 'get',
			headers: !headers ? {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			}: headers
		} );
		return await rawResponse.json();
	}
	static async getObjetos( pagination = -1, headers = null ) {
        const rawResponse = await fetch(`${sessionStorage.getItem('backendUrl')}/api/objetos3ds/?populate=*&_limit=${pagination}`, {
            method: 'get',
            headers: !headers ? {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }: headers
        } );
        return await rawResponse.json();
    }
}